import { Typography } from 'components/Typography'
import './styles.scss'
import { AVAILABLE_ENVS } from '../types'
import cn from 'classnames'

interface IProps {
  version?: string
  env?: keyof typeof AVAILABLE_ENVS
}

const VersionBanner = ({ env, version }: IProps) => {
  if (
    !version ||
    !env ||
    !AVAILABLE_ENVS[env] ||
    AVAILABLE_ENVS[env] === AVAILABLE_ENVS.PROD
  ) {
    return <></>
  }
  return (
    <div
      className={cn(
        'column align-center justify-center version-banner-absolute',
        env
      )}
    >
      <Typography.Label>{`v${version}`}</Typography.Label>
      <Typography.Label>{AVAILABLE_ENVS[env]}</Typography.Label>
    </div>
  )
}

export default VersionBanner
